export const COMPANY = {
  name: 'Europa Comercial Ltda.',
  cnpj: '32.463.085/0001-30',
  address: 'R. 2, 2-430 - Civit II, Serra - ES, 29168-081',
  brandColor: '#F5821F',
  appName: 'Porta a Porta',
  appTagline: 'Gestão de visitas a clientes',
  version: '1.6.4',
};
